<template src="./CoreBMSMatchList.html">
</template>

<script>
  export default {
    name: "List",
    props: {
      title: {
        type: String
      },
      pagination: {
        type: Boolean
      },
      search: {
        type: Boolean
      },
      items: {
        type: Array
      },
      fields: {
        type: Array
      },
      filterOn: {
        type: Array
      },
      filter: null,
      idProperty: {
        type: String
      },
      initialValue: {
        type: String
      },
      searchContext: {
        type: String
      },
      bpUrl: {
        type: String
      },
      showSync: {
        type: Boolean
      },
      syncFunction: {
        type: Function
      },
      viewCoreClientFunction: {
        type: Function
      },
      destination: {
        type: String
      },
    },
    data() {
      return {
        keyword: "",
        currentPage: 1,
        perPage: 10,
        pageOptions: [5, 10, 15],
        selectMode: 'single',
        filteredRowCount: null,
        initialValueCleared: false,
        selectedClientToSync: null
      }
    },
    watch: {
      items: {
        immediate: true,
        deep: true,
        handler(newVal, oldVal) {
          if (newVal) {
            // A fresh result set landed - don't leave the user stranded on a
            // page number that may no longer exist for this search.
            this.currentPage = 1;

            if (this.initialValue && !this.initialValueCleared) {
              var matchedRow = newVal.find(x => x[this.idProperty] == this.initialValue);
              if (matchedRow) {
                matchedRow.isSelected = true;
                this.$emit('selectionChanged', this.initialValue);
                this.initialValueCleared = true;
              }
            }
          }
        }
      }
    },
    methods: {
      onFiltered(filteredItems) {
        if (filteredItems) {
          this.filteredRowCount = filteredItems.length;
        }
      },
      selectSyncItem(clientId) {
        this.selectedClientToSync = clientId;
      },
      selectCoreItem(item) {
        this.viewCoreClientFunction(item);
      },
      rowSelected(selected, row) {
        this.initialValueCleared = true;
        if (selected) {
          var previousSelected = this.items.find(x => x.isSelected);
          if (previousSelected)
            previousSelected.isSelected = false;
          if (this.searchContext === 'bpAccount')
            this.$emit('selectionChanged', row.accountId);
          else if (this.searchContext === 'epicAccount')
            this.$emit('selectionChanged', row.clientId);
          else if (this.searchContext === 'bpContact')
            this.$emit('selectionChanged', row.contactId);
          else if (this.searchContext === 'epicContact')
            this.$emit('selectionChanged', row.contactID);
        }
        else
          this.$emit('selectionChanged', 0)
      },
      getBPUrl(row) {
        return this.bpUrl + '/broker/viewClientAccount.do?clientId=' + row.item.accountId;
      },
      getStatus(data) {
        if (data.value === true)
          return this.$t('Active');
        else if (data.value === false)
          return this.$t('Inactive');
        else
          return '';
      },
      getClientType(data) {
        if (data.value == 'P')
          return this.$t('Prospect');
        else if (data.value == 'I')
          return this.$t('Insured');
        else
          return '';
      },
      getAgency(data) {
        if (data.item.structures != null) {
          if (data.item.structures[0] != null) {
            return data.item.structures[0].agencyCode;
          }
        }
      },
      getEpicDestination(data) {
        if (data.item.destination != null) {
          return "Epic " + data.item.destination
        }
      }
    },
    computed: {
      getTotalRows: {
        get() {
          if (this.filteredRowCount) {
            return this.filteredRowCount;
          }
          else {
            return this.items.length;
          }
        }
      },
      setFilter: {
        get() {
          return this.filter ? this.filter : ''
        },
        set(setFilter) {
          this.$emit('change', setFilter)
        }
      }
    }
  }
</script>
